<template>
  <div class="d-flex flex-wrap w-100 max-w-xl mx-auto">
    <div class="w-100 item-outer col p-3">
      <div class="border h-100 flex flex-col justify-between align-items-center rounded item_border item_border_arrow relative border_main11">
        <div class="p-2 w-100 gept_main_bg flex align-items-center justify-between">
          <p class="font-bold text-white md:text-lg text-center">{{ $t('GEPT.testing.inputTest') }}</p>
          <p class="font-bold text-white md:text-lg text-center">{{ $t('GEPT.common.wordsCount', { count: textLength }) }}</p>
        </div>
        <div class="p-3 px-3 mb-1 pointer w-100">
          <textarea v-model="inputVal" name="TestingTools" id="" rows="5" class="border rounded w-100 p-2 border_main13" :placeholder="$t('GEPT.testing.inputPlaceholder')"></textarea>
        </div>

        <div class="p-3">
          <p class="gept_main_color md:text-lg text-center font-semibold">{{ $t('GEPT.testing.inputDesc') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestingTools',
  props: {
  },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    textLength () {
      if (this.inputVal) {
        let words = this.inputVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
        let wordCount = words.filter(word => word.length > 0).length
        return wordCount
      }
      return 0
    }
  },
  watch: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>
